module.exports = __webpack_public_path__ + "img/tools.680d5301.svg";